import { render, staticRenderFns } from "./DashboardTourLauncher.vue?vue&type=template&id=4346e7b4&scoped=true"
import script from "./DashboardTourLauncher.vue?vue&type=script&lang=js"
export * from "./DashboardTourLauncher.vue?vue&type=script&lang=js"
import style0 from "./DashboardTourLauncher.vue?vue&type=style&index=0&id=4346e7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4346e7b4",
  null
  
)

export default component.exports